module.exports = __webpack_public_path__ + "media/images/prize__matchday@2x-311cb533b3ed01afc4a70fb3be876301.jpg";